export default __webpack_public_path__ + "media/background-mobile-intl.96f804a32469c5139cc580dcd14ebf0b.webp";